<template>
  <div
    class="flex border-t border-solid border-white min-h-[60px] justify-between items-center text-stone text-bodyLg sm:text-bodyXl"
  >
    <div><slot name="label"></slot></div>
    <div class="flex items-center"><slot name="control"></slot></div>
  </div>
</template>
